import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { InfoBarViewStates } from 'owa-calendar-info-bar/lib/utils/allViewStates';

/**
 * Display a message informing the user editing an existing draft message
 * that the message or the message updates have not been sent
 * @param originalEvent
 */
export default (originalEvent: CalendarEvent) => {
    const shouldShowInfoMeetingInvitationNotSent =
        originalEvent.IsOrganizer &&
        originalEvent.IsMeeting &&
        !originalEvent.MeetingRequestWasSent &&
        originalEvent.ItemId;
    const getInfoMeetingUpdatesNotSent =
        originalEvent.IsOrganizer &&
        originalEvent.IsMeeting &&
        originalEvent.IsDraft &&
        originalEvent.MeetingRequestWasSent;

    let infobarViewStates = [];
    if (shouldShowInfoMeetingInvitationNotSent) {
        infobarViewStates.push(InfoBarViewStates.getInfoMeetingInvitationNotSent());
    }

    if (getInfoMeetingUpdatesNotSent) {
        infobarViewStates.push(InfoBarViewStates.getInfoMeetingUpdatesNotSent());
    }

    return infobarViewStates;
};
